/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-08-26 11:37:41
 * @LastEditors: tangshuo
 * @LastEditTime: 2023-04-14 17:46:31
 */
import React, { FC, useRef, useEffect, useState } from 'react';
import { Tabs, Dropdown, Menu, Icon } from '@firesoon/antd';
import classNames from 'classnames';
import { isArray } from 'lodash';
import { FSTabsProps } from './interface';

import './index.less';

const FS_TABS = 'fs-tabs';
const FS_TABS_MORE = 'fs-tabs-tab-more';
const FS_TABS_DROPDOWN = 'fs-tabs-dropdown';

const Index: FC<FSTabsProps> = (props) => {
  const ref: any = useRef(null);
  const TabRef: any = useRef(null);
  const {
    children = [],
    className = '',
    isPill = false,
    hideMore = false,
    onChange,
    defaultActiveKey,
    ...rest
  }: any = props;
  const childrenAry = isArray(children) ? children : [children];
  const formatChildren = childrenAry?.filter((i) => i);
  const [scrollArrow, setScrollArrow] = useState(false);
  const [activeKey, setAction] = useState(defaultActiveKey || formatChildren[0]?.key);
  useEffect(() => {
    showMore();
  }, []);

  useEffect(() => {
    if (formatChildren?.length) {
      showMore();
    }
  }, [formatChildren?.length]);

  useEffect(() => {
    if (props?.activeKey) {
      setAction(props?.activeKey);
    }
  }, [props?.activeKey]);

  const showMore = () => {
    setTimeout(() => {
      const scrollArrow = ref.current?.getElementsByClassName('ant-tabs-tab-arrow-show')?.length;
      setScrollArrow(Boolean(scrollArrow));
    }, 0);
  };

  const tabChange = (key) => {
    setAction(key);
    if (onChange) {
      onChange(key);
    }
  };

  const moreClick = (e) => {
    TabRef.current?.handleChange(e.key);
  };

  const closeTab = (e, key) => {
    e.stopPropagation();
    TabRef.current?.removeTab(key, e);
  };

  const More = (
    <div>
      <Dropdown
        overlayClassName={FS_TABS_DROPDOWN}
        overlay={
          <Menu onClick={moreClick}>
            {formatChildren
              ?.filter((i) => i)
              ?.map((i) => (
                <Menu.Item key={i.key}>
                  {i.props?.tab}
                  <Icon onClick={(e) => closeTab(e, i.key)} type="close" />
                </Menu.Item>
              ))}
          </Menu>
        }
      >
        <div className={FS_TABS_MORE}>...</div>
      </Dropdown>
      {props?.tabBarExtraContent}
    </div>
  );

  return (
    <div className="fs-tabs-wrapper" ref={ref}>
      <Tabs
        ref={TabRef}
        activeKey={activeKey}
        tabBarExtraContent={scrollArrow && !hideMore ? More : props?.tabBarExtraContent}
        className={classNames(FS_TABS, className, {
          'fs-tabs-pill': isPill,
        })}
        onChange={tabChange}
        {...rest}
      >
        {formatChildren}
      </Tabs>
    </div>
  );
};

export default Index;
